export default () => ({
  nav: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 20,
  },
});
